import request from './request'

export function listStoppage(data) {
  return request.post('/production/stoppages/list', data)
}
export function statsStoppage(data) {
  return request.post('/production/stoppages/stats', data || {})
}
export function getStoppage(id) {
  return request.get('/production/stoppages/' + id)
}
export function saveStoppage(data) {
  return request.post('/production/stoppages', data)
}
export function updateStoppage(data) {
  return request.post('/production/stoppages/update', data)
}
export function finishStoppage(data) {
  return request.post('/production/stoppages/finish', data)
}
export function deleteStoppage(ids) {
  return request.post('/production/stoppages/delete', ids)
}
